import classNames from 'classnames';
import React from 'react';
import style from './line.module.scss';

const Line = ({ className }) => {
  return <div className={classNames(style.line, className)}></div>;
};

export default Line;
